import React from 'react';

import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';

import { QuestionType } from 'components/modules/questions/types';

import SortableQuestionsList from '../SortableQuestionsList';

const propTypes = {
  questions: PropTypes.arrayOf(QuestionType).isRequired,
  onRemove: PropTypes.func.isRequired,
  onSortEnd: PropTypes.func.isRequired,
};

const defaultProps = {};

export default function GroupQuestions({ questions, onRemove, onSortEnd }) {
  return (
    <div className="questions-in-group">
      <p className="sort-instructions">
        <Icon name="info circle" />
        Drag questions to reorder them within the group
      </p>
      <SortableQuestionsList
        questions={questions}
        onRemove={onRemove}
        onSortEnd={onSortEnd}
        useDragHandle
        helperClass="sortable-helper"
      />
    </div>
  );
}

GroupQuestions.propTypes = propTypes;
GroupQuestions.defaultProps = defaultProps;
